<template>
  <v-dialog v-model="show_modal" persistent max-width="800">
    <v-card>
      <v-card-title>
        ตั้งค่ารายละเอียดค่าธรรมเนียมการศึกษา (ลบ) <br />
        {{ level == 2 ? "ระดับปริญญาโท" : "ระดับปริญญาเอก" }}
      </v-card-title>
      <v-card-text>
        ต้องการลบข้อมูล<br /><br />
        <v-row>
          <v-col class="pt-0 pb-0" cols="12" md="12">
            <v-chip color="black" dark class="mr-2">
              {{ name_faculty }}
            </v-chip>
            <v-chip color="gray" class="mr-2">
              {{ name_curriculum }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" cols="12" md="12">
            <v-chip color="orange" dark class="mr-2">
              ปีรับเข้า {{ semester }}/{{ year }}
            </v-chip>
            <v-chip color="blue" dark class="mr-2">
              ประเภทการรับเข้า : {{ name_admis_type }}
            </v-chip>
            <v-chip color="green" dark class="mr-2">
              สำหรับ :
              <span
                class="ml-1"
                :style="{
                  color:
                    name_thai_or_foreign == 'นักศึกษาต่างชาติ' ? 'blue' : '',
                }"
              >
                {{ name_thai_or_foreign }}</span
              >
            </v-chip>
            <v-chip color="red" dark class="mr-2">
              แผนการศึกษา : {{ name_study_plan }}
            </v-chip>
          </v-col>
        </v-row>
        <br /><br />
        หรือไม่ ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="delete_modal()">
          {{ $t("config_academic.confirm") }}</v-btn
        >
        <v-btn color="error" dark @click="show_modal = false">{{
          $t("config_academic.cancel")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfigProvider from "@/services/config.provider";
const configService = new ConfigProvider();

export default {
  name: "ConfigGraduateCurriculumFeeDeleteDialog",

  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },

  data: () => ({
    show_modal: false,

    level: null,
    faculty_id: null,
    curriculum_id: null,
    admis_type_id: null,
    year: null,
    semester: null,
    thai_or_foreign: null,
    prog_id: null,
    name_faculty: null,
    name_curriculum: null,
    name_admis_type: null,
    name_thai_or_foreign: null,
    name_study_plan: null,
  }),

  computed: {},

  methods: {
    open_delete_modal: function (
      selected_level,
      selected_faculty_id,
      selected_curriculum_id,
      selected_year,
      selected_semester,
      selected_admis_type_id,
      selected_thai_or_foreign,
      selected_prog_id,
      name_faculty,
      name_curriculum,
      name_admis_type,
      name_thai_or_foreign,
      name_study_plan,
      item
    ) {
      this.show_modal = true;
      this.level = selected_level;
      this.faculty_id = selected_faculty_id;
      this.curriculum_id = selected_curriculum_id;
      this.year = selected_year;
      this.semester = selected_semester;
      this.admis_type_id = item.admis_type;
      this.thai_or_foreign = item.inter_student;
      this.prog_id = item.prog_id;
      this.name_faculty = name_faculty;
      this.name_curriculum = name_curriculum;
      this.name_admis_type = item.admis_type_name;
      this.name_thai_or_foreign =
        item.inter_student == 1 ? "นักศึกษาต่างชาติ" : "นักศึกษาไทย";
      this.name_study_plan = item.study_plan_name;
    },

    delete_modal: async function () {
      this.toggle_loading(true);
      let response = await configService
        .deleteGraduateCurriculumFee({
          faculty_id: this.faculty_id,
          curr_id: this.curriculum_id,
          admis_type: this.admis_type_id,
          admis_year: this.year,
          admis_term: this.semester,
          inter_student: this.thai_or_foreign,
          prog_id: this.prog_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
      this.show_modal = false;
      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else {
        this.$toasted.error(this.$t("toasted.cannot_delete"), {
          duration: 0,
        });
      }
    },
  },
};
</script>
